import { Component } from 'react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { PasswordLayout } from '../PasswordLayout';
import { PasswordEntities } from '../PasswordEntities';
import { PasswordRouterProps } from '../PasswordRouterProps';

export interface TemplateViewPageProps extends NSARouterMakerResult, PasswordRouterProps {}

class TemplateViewPage extends Component<TemplateViewPageProps>
{
    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                pages={{
                    entity: PasswordEntities.template(this.props),
                    view: {}
                }}
            >
                <></>
            </PasswordLayout >
        )
    }
}

export default TemplateViewPage